const BRUZZ_NEWS_ACTUA = "actua";
const BRUZZ_NEWS_UIT = "uit";
const BRUZZ_NEWS_KIEST = "brussel-kiest";
const BRUZZ_NEWS_KIEST_2019 = "brussel-kiest-2019";

class NowOnBruzzService {
  static getNowOnBruzzNews = async (type = BRUZZ_NEWS_ACTUA) => {
    let url = "/api/content";
    switch (type) {
      case BRUZZ_NEWS_UIT:
        url = `${url}/uit`;
        break;
      case BRUZZ_NEWS_KIEST:
        url = `${url}/brussel-kiest`;
        break;
      case BRUZZ_NEWS_KIEST_2019:
        url = `${url}/brussel-kiest-2019`;
        break;
      case BRUZZ_NEWS_ACTUA:
      default:
        url = `${url}/homepage`;
        break;
    }

    const response = await fetch(url, {
      method: "GET",
      credentials: "same-origin",
    });

    return response.json();
  };
}

export default NowOnBruzzService;
